import { useEffect } from "react";
import { readRecoveryDelay } from "../api/client";

/** A verified session lets failed reads recover; healthy panels and writes stay idle. */
export function useVerifiedReadRecovery(error: unknown, refresh: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled || readRecoveryDelay(error, 0) === undefined) return;
    const recover = () => { if (!document.hidden) refresh(); };
    window.addEventListener("mzn:session-verified", recover);
    return () => window.removeEventListener("mzn:session-verified", recover);
  }, [enabled, error, refresh]);
}
